/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_SlotInputs */

const cs_builder_prop_slot = /** @type {(inputs: Builder_Prop_SlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediální slot`)
};

const en_builder_prop_slot = /** @type {(inputs: Builder_Prop_SlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media slot`)
};

/**
* | output |
* | --- |
* | "Media slot" |
*
* @param {Builder_Prop_SlotInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_slot = /** @type {((inputs?: Builder_Prop_SlotInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_SlotInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_slot(inputs)
	return cs_builder_prop_slot(inputs)
});